import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { withTranslation, useTranslation } from "react-i18next";
import { usePreCheckInContext } from "./contexts/PreCheckInContext";
import { get, isEmpty } from "lodash";
import moment from "moment";
import Mustache from "mustache";

import Booking from "../../model/booking";
import PaymentService from "../../backend/PaymentService";
import Property from "../../model/property";
import FulfillmentService from "../../backend/FulfillmentService";

const CardList = () => {
  const [currentGuest, setCurrentGuest] = useState();
  const [newCard, setNewCard] = useState(false);
  const [card, setCard] = useState({});
  const {
    propertyUid,
    bookingNumber,
    userEmail,
    language,
    data: {
      guestService,
      configuration,
      presets,
      accessToken,
      booking,
      guests,
    },
    components: { PreCheckInHeader, PreCheckInContainer },
    func: { setLoading, updateErrorPage, setAccessTokenData },
  } = usePreCheckInContext();

  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [isPageMounted, setIsPageMounted] = useState(true);
  useEffect(() => {
    if (guests && isEmpty(currentGuest)) {
      const tmpGuests = [...guests.allGuests()];
      let index = tmpGuests.findIndex((item) => item.currentGuest);
      const currGuest = tmpGuests[index !== -1 ? index : 0];
      setCurrentGuest(currGuest);
    }
  }, [guests, currentGuest]);

  useEffect(() => {
    if (isEmpty(card) && !newCard && bookingNumber) {
      const query = new URLSearchParams(location.search);
      const newTransactionId = query.get("transaction_id");
      setNewCard(
        query.get("added_card") ||
          (newTransactionId && query.get("holder_name")) ||
          false
      );

      let cardInfo = Booking.getCard(bookingNumber);
      if (query.has("transaction_id") && query.has("holder_name")) {
        cardInfo = {
          newTransactionId,
          cardholderName: query.get("holder_name"),
          cardNumber: query.get("last_4"),
          cvcCcv: query.get("card_type"),
          expMmYy: query.get("exp_date"),
        };
        Booking.setCard(bookingNumber, cardInfo);
      }
      setCard(cardInfo);
      setNewCard(!isEmpty(cardInfo));
    }
  }, [location.search, card, bookingNumber, newCard]);

  const goToNewCard = async () => {
    if (presets.demoMode) {
      history.push(
        `/pre-checkin/${propertyUid}/booking/${bookingNumber}/cards/new?language=${language}&email=${encodeURIComponent(
          userEmail
        )}`
      );
    } else {
      try {
        setLoading(true);
        switch (configuration.paymentType) {
          case "Celo":
            await getCeloServiceToken();
            break;
          case "Adyen":
            await getAdyenSession();
            break;
          case "Windcave":
            await getWindcaveSessionLink();
            break;
          case "global_blue":
            await postGlobalBlueSessionLink();
            break;
          default:
            // Reddot
            await postReddotPayment();
        }
      } catch (err) {
        updateErrorPage();
        console.error(err);
      }
    }
  };

  const getAdyenSession = async () => {
    const returnUrl = window.location.href;
    const total = booking.pre_auth_amount.total_pre_auth;
    const totalCents = booking.pre_auth_amount.total_pre_auth_cents;
    const currency = booking.currency;
    const bookingParams = {
      title: currentGuest.title,
      first_name: currentGuest.firstName,
      last_name: currentGuest.lastName,
      email: currentGuest.email,
      nationality_code: currentGuest.nationalityCode,
      dob: moment.utc(currentGuest.birthday).format("YYYY-MM-DD"),
      phone: { phone_number: `${currentGuest.phoneCode}${currentGuest.phone}` },
      address: { country_of_residence_code: currentGuest.countryCode },
      user_token: Booking.getUserToken(propertyUid),
    };
    await FulfillmentService.createAdyenPreAuthSession(
      guestService.core_id,
      propertyUid,
      returnUrl,
      total,
      currency,
      language,
      bookingParams,
      accessToken || Booking.getUserToken(propertyUid)
    )
      .then(function (result) {
        Property.setPaymentId(result.data);
        Property.setPaymentTransaction(result.data.payment_transaction);
        const allStates = {
          currency,
          returnUrl,
          total,
          totalCents,
          language,
          countryCode: currentGuest.countryCode,
          pathname: `/pre-checkin/${propertyUid}/booking/${bookingNumber}/cards?language=${language}`,
          reference: result.data.payment_transaction.reference,
          sessionData: result.data.session,
          extraCharges: [],
          adyenEnv: result.data.environment,
          clientKey: result.data.client_key,
        };
        setLoading(false);
        history.push({
          pathname: `/pre-checkin/${propertyUid}/booking/${bookingNumber}/pre-auth-dropin`,
          state: allStates,
        });
      })
      .catch((error) => {
        if (get(error.response, "status") === 401) {
          setAccessTokenData();
        }
        console.error(error);
        setLoading(false);
        updateErrorPage(true);
      });
  };

  const postReddotPayment = async () => {
    let newAccessToken = accessToken;
    if (isEmpty(newAccessToken)) newAccessToken = await setAccessTokenData();
    PaymentService.postReddotPayment(newAccessToken, {
      node_id: guestService.core_id,
      booking_number: bookingNumber,
      property_uid: propertyUid,
      webstore_url: window.location.href,
      booking: {
        title: currentGuest.title,
        first_name: currentGuest.firstName,
        last_name: currentGuest.lastName,
        email: currentGuest.email,
        nationality_code: currentGuest.nationalityCode,
        dob: moment.utc(currentGuest.birthday).format("YYYY-MM-DD"),
        phone: {
          phone_number: `${currentGuest.phoneCode}${currentGuest.phone}`,
        },
        address: { country_of_residence_code: currentGuest.countryCode },
      },
    })
      .then((response) => {
        setLoading(false);
        window.location.href = response.data.payment_url;
      })
      .catch((error) => {
        if (get(error.response, "status") === 401) {
          setAccessTokenData();
        }
        console.error(error);
        updateErrorPage(true);
      });
  };

  const getCeloServiceToken = async () => {
    let newAccessToken = accessToken;
    if (isEmpty(newAccessToken)) newAccessToken = await setAccessTokenData();
    const response = await PaymentService.getServiceToken(
      newAccessToken,
      guestService.core_id
    );
    Booking.setServiceToken(bookingNumber, response.data);
  };

  const getWindcaveSessionLink = async () => {
    const total = booking.pre_auth_amount.total_pre_auth;
    const currency = "AUD" || booking.currency;
    const returnUrl = window.location.href;
    let newAccessToken = accessToken;
    if (isEmpty(newAccessToken)) newAccessToken = await setAccessTokenData();
    PaymentService.postWindcaveLink(newAccessToken, {
      payment_action: "pre_auth",
      node_id: guestService.core_id,
      booking_number: bookingNumber,
      property_uid: propertyUid,
      resv_id: booking.resv_id,
      webstore_url: window.location.href,
      windcave_payload: {
        amount: total,
        currency: currency,
        callbackUrls: {
          approved: returnUrl,
          cancelled: returnUrl,
        },
      },
      booking: {
        title: currentGuest.title,
        first_name: currentGuest.firstName,
        last_name: currentGuest.lastName,
        email: currentGuest.email,
        nationality_code: currentGuest.nationalityCode,
        dob: moment.utc(currentGuest.birthday).format("YYYY-MM-DD"),
        phone: {
          phone_number: `${currentGuest.phoneCode}${currentGuest.phone}`,
        },
        address: { country_of_residence_code: currentGuest.countryCode },
      },
    })
      .then((response) => {
        getWindcaveSessionLinkStatus(
          get(response.data, "job_id"),
          currentGuest.email
        );
      })
      .catch((error) => {
        if (get(error.response, "status") === 401) {
          setAccessTokenData();
        }
        console.error(error);
        updateErrorPage(true);
      });
  };

  const getWindcaveSessionLinkStatus = async (jobId, email) => {
    if (!jobId) {
      updateErrorPage();
      return;
    }

    PaymentService.getWindcaveLinkStatus(accessToken, jobId, email)
      .then((response) => {
        handleWindcaveSessionLink(jobId, email, response);
      })
      .catch((error) => {
        if (get(error.response, "status") === 401) {
          setAccessTokenData();
        }
        console.error(error);
        updateErrorPage(true);
      });
  };

  const handleWindcaveSessionLink = async (jobId, email, response) => {
    if (get(response.data, "status") === "fetching") {
      setTimeout(() => {
        getWindcaveSessionLinkStatus(jobId, email);
      }, 3000); // set timer to call the booking api
    } else if (["finish", "ok"].includes(get(response.data, "status"))) {
      Booking.setServiceToken(bookingNumber, response.data);
      const links = get(response.data, "payment_link.links", []);
      const itemWithRelHpp = links.find((link) => link.rel === "hpp");
      window.location.href = get(itemWithRelHpp, "href");
    } else {
      updateErrorPage();
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const postWindcaveTransaction = async (sessionId) => {
    setLoading(true);
    PaymentService.postWindcaveTransaction(accessToken, {
      node_id: guestService.core_id,
      booking_number: bookingNumber,
      property_uid: propertyUid,
      resv_id: booking.resv_id,
      session_id: sessionId,
      booking: {
        title: currentGuest.title,
        first_name: currentGuest.firstName,
        last_name: currentGuest.lastName,
        email: currentGuest.email,
        nationality_code: currentGuest.nationalityCode,
        dob: moment.utc(currentGuest.birthday).format("YYYY-MM-DD"),
        phone: {
          phone_number: `${currentGuest.phoneCode}${currentGuest.phone}`,
        },
        address: { country_of_residence_code: currentGuest.countryCode },
      },
    })
      .then((response) => {
        getWindcaveTransactionStatus(get(response.data, "job_id"));
      })
      .catch((err) => {
        updateErrorPage();
        console.error(err);
      });
  };

  const getWindcaveTransactionStatus = async (jobId) => {
    PaymentService.getWindcaveTransactionStatus(
      accessToken,
      jobId,
      currentGuest.email
    )
      .then((response) => {
        handleWindcaveTransaction(jobId, response);
      })
      .catch((error) => {
        if (get(error.response, "status") === 401) {
          setAccessTokenData();
        }
        console.error(error);
        updateErrorPage(true);
      });
  };

  const handleWindcaveTransaction = async (jobId, response) => {
    if (get(response.data, "status") === "fetching") {
      setTimeout(() => {
        getWindcaveTransactionStatus(jobId);
      }, 3000); // set timer to call the booking api
    } else if (["finish", "ok"].includes(get(response.data, "status"))) {
      const card = {
        cardholderName: get(
          response.data,
          "transaction_response.card.card_holder_name"
        ),
        cardNumber: get(
          response.data,
          "transaction_response.card.last_four_digits"
        ),
        expMmYy: get(
          response.data,
          "transaction_response.card.date_expiry_year"
        ),
        type: get(response.data, "transaction_response.card.payment_type"),
        transactionId: get(
          response.data,
          "transaction_response.transaction_id"
        ),
      };
      Property.setPaymentId(response.data);
      Booking.setPaymentTransactionID(
        "payment_transaction",
        get(response.data, "transaction_response.payment_transaction")
      );
      setNewCard(true);
      setCard(card);
      Booking.setCard(bookingNumber, card);
      setLoading(false);
    } else {
      if (get(response.data, "error") === "VERIFICATION_NAME_MISMATCH") {
        updateErrorPage(
          true,
          t("FAILURE"),
          t(
            "VERIFICATION_NAME_MISMATCH",
            "We have detected that the name on your ID do not match the name on the provided credit card used for payment. Please proceed to the frontdesk to complete your check-in."
          )
        );
      } else {
        updateErrorPage();
      }
    }
  };

  const postGlobalBlueSessionLink = async () => {
    const total = booking.pre_auth_amount.total_pre_auth;
    const currency = booking.currency;
    const returnUrl = window.location.href;
    PaymentService.postGlobalBlueLink(accessToken, {
      payment_action: "pre_auth",
      node_id: guestService.core_id,
      booking_number: bookingNumber,
      property_uid: propertyUid,
      resv_id: booking.resv_id,
      webstore_url: window.location.href,
      global_blue_payload: {
        amount: total,
        currency: currency,
        successUrl: returnUrl,
        cancelUrl: returnUrl,
      },
      booking: {
        title: currentGuest.title,
        first_name: currentGuest.firstName,
        last_name: currentGuest.lastName,
        email: currentGuest.email,
        nationality_code: currentGuest.nationalityCode,
        dob: moment.utc(currentGuest.birthday).format("YYYY-MM-DD"),
        phone: {
          phone_number: `${currentGuest.phoneCode}${currentGuest.phone}`,
        },
        address: { country_of_residence_code: currentGuest.countryCode },
      },
    })
      .then((response) => {
        getGlobalBlueSessionLinkStatus(
          get(response.data, "job_id"),
          currentGuest.email
        );
      })
      .catch((err) => {
        updateErrorPage();
        console.error(err);
      });
  };

  const getGlobalBlueSessionLinkStatus = async (jobId, email) => {
    if (!jobId) {
      updateErrorPage();
      return;
    }

    PaymentService.getGlobalBlueLinkStatus(accessToken, jobId, email)
      .then((response) => {
        handleGlobalBlueSessionLink(jobId, email, response);
      })
      .catch((error) => {
        if (get(error.response, "status") === 401) {
          setAccessTokenData();
        }
        console.error(error);
        updateErrorPage(true);
      });
  };

  const handleGlobalBlueSessionLink = async (jobId, email, response) => {
    if (get(response.data, "status") === "fetching") {
      setTimeout(() => {
        getGlobalBlueSessionLinkStatus(jobId, email);
      }, 3000); // set timer to call the booking api
    } else if (["finish", "ok"].includes(get(response.data, "status"))) {
      Booking.setServiceToken(bookingNumber, response.data);
      const success = get(response.data, "payment_link.success");
      const redirectUrl = get(response.data, "payment_link.redirectUrl");
      if (success && redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        updateErrorPage();
      }
    } else {
      updateErrorPage();
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const postGlobalBlueTransaction = async (transactionId) => {
    setLoading(true);

    PaymentService.postGlobalBlueTransaction(accessToken, {
      node_id: guestService.core_id,
      booking_number: bookingNumber,
      property_uid: propertyUid,
      resv_id: booking.resv_id,
      transaction_id: transactionId,
      booking: {
        title: currentGuest.title,
        first_name: currentGuest.firstName,
        last_name: currentGuest.lastName,
        email: currentGuest.email,
        nationality_code: currentGuest.nationalityCode,
        dob: moment.utc(currentGuest.birthday).format("YYYY-MM-DD"),
        phone: {
          phone_number: `${currentGuest.phoneCode}${currentGuest.phone}`,
        },
        address: { country_of_residence_code: currentGuest.countryCode },
      },
    })
      .then((response) => {
        getGlobalBlueTransactionStatus(get(response.data, "job_id"));
      })
      .catch((err) => {
        updateErrorPage();
        console.error(err);
      });
  };

  const getGlobalBlueTransactionStatus = async (jobId) => {
    PaymentService.getGlobalBlueTransactionStatus(
      accessToken,
      jobId,
      currentGuest.email
    )
      .then((response) => {
        handleGlobalBlueTransaction(jobId, response);
      })
      .catch((error) => {
        if (get(error.response, "status") === 401) {
          setAccessTokenData();
        }
        console.error(error);
        updateErrorPage(true);
      });
  };

  const handleGlobalBlueTransaction = async (jobId, response) => {
    if (get(response.data, "status") === "fetching") {
      setTimeout(() => {
        getGlobalBlueTransactionStatus(jobId);
      }, 3000); // set timer to call the booking api
    } else if (["finish", "ok"].includes(get(response.data, "status"))) {
      const responseCode =
        get(
          response.data,
          "global_blue_transaction_response.transactionStatus"
        ) === "SUCCESS";
      if (responseCode) {
        const transaction = get(
          response.data,
          "global_blue_transaction_response"
        );
        if (transaction) {
          const lastFour = get(transaction, "returnData.lastFourDigits");
          const card = {
            cardholderName: get(transaction, "returnData.cardHolder"),
            cardNumber: lastFour,
            expMmYy: `${get(transaction, "returnData.expiryMonth")}/${get(
              transaction,
              "returnData.expiryYear"
            )}`,
            type: get(transaction, "returnData.type"),
            transactionId: get(transaction, "merchantTransactionId"),
          };
          setNewCard(true);
          Booking.setCard(bookingNumber, card);
        }
        history.push(
          `/pre-checkin/${propertyUid}/booking/${bookingNumber}/cards?language=${language}&email=${encodeURIComponent(
            userEmail
          )}`
        );
        setLoading(false);
      } else {
        updateErrorPage();
      }
    } else {
      updateErrorPage();
    }
  };

  const goToSkip = () => {
    Booking.setCard(bookingNumber, null);
    // setState({ loading: false, error: false });
    goToAdditionalInformation();
  };

  const goToConfirmation = () => {
    // setState({ loading: false, error: false });
    goToAdditionalInformation();
  };

  const goToAdditionalInformation = () => {
    history.push(
      `/pre-checkin/${propertyUid}/booking/${bookingNumber}/additional-information?language=${language}`
    );
  };

  const createPaymentToken = useCallback(
    async (sessionId, transactionId, paymentType) => {
      if (sessionId && paymentType === "Windcave") {
        await postWindcaveTransaction(sessionId);
      } else if (transactionId && paymentType === "global_blue") {
        await postGlobalBlueTransaction(transactionId);
      }
    },
    [postWindcaveTransaction, postGlobalBlueTransaction]
  );

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const newSessionId = query.get("sessionId");
    const newTransactionId = query.get("transaction_id");
    if (
      isPageMounted &&
      bookingNumber &&
      configuration &&
      booking &&
      !isEmpty(currentGuest) &&
      (newSessionId || newTransactionId)
    ) {
      setIsPageMounted(false);
      createPaymentToken(
        newSessionId,
        newTransactionId,
        configuration.paymentType
      );
      return () => {};
    }
  }, [
    location.search,
    isPageMounted,
    bookingNumber,
    configuration,
    booking,
    currentGuest,
    createPaymentToken,
  ]);

  return (
    <>
      <PreCheckInContainer containerName="card-list">
        <PreCheckInHeader
          title={t("DEPOSIT_INFORMATION")}
          headerLink
        />
        {guestService && booking && (
          <>
            <section
              id="content"
              className="relative flex flex-col px-9 w-full flex-1 md:flex-0 pt-6">
              <div>
                <p
                  className="type-regular xLarge mb-8 mt-6"
                  style={{ color: presets.backgroundColorTopBar }}>
                  {guestService.depositInformationTitle}
                </p>
                <p className="type-regular medium mb-8 mt-6 pb-4 border-b whitespace-pre-line">
                  {Mustache.render(guestService.depositInformation, {
                    amount: booking.amountDescription,
                  })}
                </p>

                {card === null && (
                  <div className="md:max-w-2xl text-center mx-auto">
                    <button
                      className={`mb-4 uppercase preCheckinSubTitle font-normal text-16 text-center w-full py-6 border-2 ${presets.buttonStyleName}`}
                      style={{
                        borderColor: presets.backgroundColorTopBar,
                      }}
                      title={t("ADD_CARD")}
                      onClick={() => goToNewCard()}>
                      <p>+</p>
                      <p>{t("ADD_CARD")}</p>
                    </button>
                  </div>
                )}

                {newCard && card !== null && (
                  <div
                    style={{
                      borderColor: presets.backgroundColorTopBar,
                    }}
                    className="md:max-w-2xl p-10 mx-auto py-6 border-2 rounded-3xl mb-8 uppercase preCheckinSubTitle font-normal relative">
                    <span
                      className="type-regular text-12 rounded-full p-3 absolute -right-1 -top-1"
                      style={{
                        backgroundColor: presets.backgroundColorTopBar,
                        color: presets.appHomeTextCallToAction,
                      }}>
                      {t("APPROVED")}
                    </span>
                    <p className="py-2 type-regular text-15">
                      {t("CREDIT_DEBIT_CARD", "Credit / Debit Card")}
                    </p>
                    <p className="py-2 mb-4 type-regular text-15">
                      {`**** **** **** ${card.cardNumber}`}
                    </p>
                    <div className="grid grid-cols-2 gap-4">
                      <p className="type-regular text-14">{t("CARDHOLDER")}</p>
                      <p className="text-right type-regular text-14">
                        {t("EXPIRES")}
                      </p>
                      <p className="type-regular text-12">
                        {card.cardholderName}
                      </p>
                      <p className="type-regular text-12 text-right">
                        **/{card.expMmYy.slice(card.expMmYy.length - 2)}
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="max-w-md mx-auto w-full mb-8">
                {guestService.skipPayment && !(newCard && card !== null) && (
                  <button
                    className={`app-button ${presets.buttonStyleName}`}
                    style={{
                      backgroundColor: presets.backgroundColorTopBar,
                      color: presets.appHomeTextCallToAction,
                    }}
                    onClick={() => goToSkip()}>
                    {t("SKIP")}
                  </button>
                )}

                {newCard && card !== null && (
                  <button
                    className={`app-button-ipad type-title medium ${presets.buttonStyleName}`}
                    style={{
                      backgroundColor: presets.backgroundColorTopBar,
                      color: presets.appHomeTextCallToAction,
                    }}
                    onClick={() => goToConfirmation()}>
                    {t("CONTINUE")}
                  </button>
                )}
              </div>
            </section>
            {newCard && card !== null && (
              <button
                className="app-button-mobile type-title medium "
                style={{
                  backgroundColor: presets.backgroundColorTopBar,
                  color: presets.appHomeTextCallToAction,
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                }}
                onClick={() => goToConfirmation()}>
                {t("CONTINUE")}
              </button>
            )}
          </>
        )}
      </PreCheckInContainer>
    </>
  );
};
export default withTranslation()(CardList);
